// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jbvjadZdUWIHIoMmC8Bf{border-bottom:1px solid var(--border-neutral-default);padding:6px 4px}.jbvjadZdUWIHIoMmC8Bf:last-of-type{border-bottom:none}.fWN6DKCYWpMDmrop5D_R{padding:0}._jwQpOgLL1k6WBrcfg_y{padding:8px}.gTqBo0EYS3sUDf5DZUhw{color:var(--light-blue-60)}.Qdx4ihOx18sbQWTc7MCR{justify-content:space-between;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `jbvjadZdUWIHIoMmC8Bf`,
	"multiSelectWrap": `fWN6DKCYWpMDmrop5D_R`,
	"title": `_jwQpOgLL1k6WBrcfg_y`,
	"selectAllButton": `gTqBo0EYS3sUDf5DZUhw`,
	"titleWrapper": `Qdx4ihOx18sbQWTc7MCR`
};
export default ___CSS_LOADER_EXPORT___;
